export default "__VITE_ASSET__CyRtWVRm__"